module.exports = __webpack_public_path__ + "img/cca-css-level-1.5c98ae7e.png";